import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main id="main-content" className="pt-[100px] min-h-screen">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
